/**
 * Drzewo dostawców aplikacji — to, co `main.tsx` montuje w `#root`.
 *
 * Wydzielone, żeby test obrazu demonstracyjnego (`test/demo-mode.test.tsx`)
 * uruchamiał DOKŁADNIE to drzewo, które jedzie w bundlu: router, React Query,
 * toasty i `DemoNotice`, a nie jego przybliżenie z pomocnika testów.
 *
 * Sesji (`AuthProvider`) tu NIE ma: montuje ją routing (`router.tsx`) dla
 * wszystkich tras poza podręcznikiem `/docs`, który ma działać bez logowania
 * i bez jednego żądania do API (ADR-0062).
 */

import { I18nextProvider } from 'react-i18next'
import type { i18n as I18n } from 'i18next'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, type createBrowserRouter } from 'react-router'
import { ToastProvider } from '@k1p4/ui'
import { shouldRetryQuery } from './api/retry'
import { DemoNotice } from './components/DemoNotice'

/** Domyślne opcje zapytań aplikacji — te same w bundlu i w teście rozruchu. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: shouldRetryQuery, refetchOnWindowFocus: false },
    },
  })
}

export interface AppRootProps {
  i18n: I18n
  queryClient: QueryClient
  router: ReturnType<typeof createBrowserRouter>
}

export function AppRoot({ i18n, queryClient, router }: AppRootProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <DemoNotice />
          <RouterProvider router={router} />
        </ToastProvider>
      </QueryClientProvider>
    </I18nextProvider>
  )
}
